<template>
	<a-modal :title="$t('introductionTeacher.introduceTeacher')" :width="850" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
		:pagination="false">
		<a-spin :spinning="codeLoading">
			<div class="ftr-1 cl-black">
				{{ $t('introductionTeacher.recommendTeacherTip') }}
			</div>
			<div class="mt-5 ftw600 ft16 cl-black">
				{{ $t('introductionTeacher.recommendTeacher') }}
			</div>
			<div class="d-flex align-items-center mt-2">
				<a-input v-model:value="account" :placeholder="$t('introductionTeacher.inputTeacherEmail')" class="ft16" style="height: 40px;" />
				<div class="bg-theme cl-w br8 ms-3 ft16 clickAct" @click="editRecommend()"
					style="width: 100px;height: 40px;line-height: 40px;text-align: center;">
					{{ $t('introductionTeacher.confirm') }}
				</div>
			</div>
			<div class="mt-5 ftw600 ft16 cl-black" v-if="list.length!=0 ">
				{{ $t('introductionTeacher.recommendedTeachers') }}
			</div>
			<div  v-if="list.length!=0 ">
				<div class="mt-2 border-gray br8 d-flex justify-content-between py-2 px-2" v-for="(item,index) in list">
					<div>
						{{item.email}}
					</div>
					<div class="">
						{{ $t('introductionTeacher.pendingReview') }}
					</div>
				</div>
			</div>
			
			<div class="d-flex justify-content-center mt-5">
				<div class="border-theme cl-theme clickAct px-3 py-1 br4 ft16" @click="handleCancel()">
					{{ $t('introductionTeacher.close') }}
				</div>
			</div>
		</a-spin>
	</a-modal>
</template>

<script>
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				codeLoading: false,
				account: '',
				list:[]
			}
		},
		created() {
			this.recommendList()
		},
		methods: {
			handleCancel() {
				this.$emit('cancel')
			},
			editRecommend(){
				this.$http.api('teacher/teacher/editRecommend',{
					email:this.account
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						this.recommendList()
						this.account = ''
					})
				})
			},
			recommendList(){
				this.$http.api('teacher/teacher/recommendList').then(res=>{
					this.list = res.list
				})
			}
		}
	}
</script>

<style>
	.ant-modal-header{
		border: none;
		text-align: center;
		padding-top: 16px;
	}
	.ant-modal-title{
		margin-top: 16px;
		font-size: 1.25rem !important;
		font-weight: 600 !important;
	}
</style>